// import { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import axiosInstance from '../../../../../../../../store/axiosInstance';
// import { SERVER_URL } from '../../../../../../../../Config/config';
// // import PDFDocument from 'pdfkit';
// // import blobStream from 'blob-stream';

// function RoadmapPage() {
//   const { state } = useLocation();
//   const [roadmap, setRoadmap] = useState(null);
//   const [selectedSkills, setSelectedSkills] = useState(state?.selectedSkills || {});
//   const [careerGoal, setCareerGoal] = useState(state?.careerGoal || 'Unknown');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchRoadmap = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const response = await axiosInstance.get(`${SERVER_URL}/api/v1/career-gpt/get-roadmap`);
//         setRoadmap(response.data.roadmap);
//       } catch (error) {
//         setError('Error fetching roadmap: ' + (error.response?.data?.error || error.message));
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (!state?.roadmap) {
//       fetchRoadmap();
//     } else {
//       setRoadmap(state.roadmap);
//       setLoading(false);
//     }
//   }, [state]);

//   console.log("Roadmap data:", roadmap);

//   // const generatePDF = () => {
//   //   const doc = new PDFDocument({ margin: 40 });
//   //   const stream = doc.pipe(blobStream());

//   //   // Header
//   //   doc.fontSize(24).text(`Career Roadmap: ${careerGoal}`, { align: 'center' });
//   //   doc.moveDown();
//   //   doc.fontSize(12).text(`Generated for User ID: 1005`, { align: 'center' });
//   //   doc.moveDown(2);

//   //   // Selected Skills
//   //   doc.fontSize(16).text('Selected Skills');
//   //   Object.entries(selectedSkills).forEach(([category, skills]) => {
//   //     if (skills.length > 0) {
//   //       doc.fontSize(12).text(`${category.charAt(0).toUpperCase() + category.slice(1)}:`);
//   //       doc.fontSize(10).text(skills.join(', '));
//   //       doc.moveDown();
//   //     }
//   //   });
//   //   doc.moveDown();

//   //   // Required Skills
//   //   doc.fontSize(16).text('Required Skills');
//   //   roadmap?.requiredSkills?.forEach(({ skill, description }) => {
//   //     doc.fontSize(12).text(`• ${skill}: ${description}`);
//   //   });
//   //   doc.moveDown();

//   //   // Skill Gap
//   //   doc.fontSize(16).text('Skill Gap Analysis');
//   //   if (roadmap?.skillGap?.missingSkill?.length) {
//   //     doc.fontSize(12).text('Missing Skills:');
//   //     doc.fontSize(10).text(roadmap.skillGap.missingSkill.join(', '));
//   //   }
//   //   if (roadmap?.skillGap?.underdevelopedSkill?.length) {
//   //     doc.fontSize(12).text('Underdeveloped Skills:');
//   //     roadmap.skillGap.underdevelopedSkill.forEach(({ skill, currentProficiency, improvementSteps }) => {
//   //       doc.fontSize(10).text(`• ${skill} (${currentProficiency}%): ${improvementSteps}`);
//   //     });
//   //   }
//   //   doc.moveDown();

//   //   // Learning Plans
//   //   ['beginner', 'intermediate', 'advanced'].forEach((level) => {
//   //     doc.fontSize(16).text(`${level.charAt(0).toUpperCase() + level.slice(1)} Learning Plan`);
//   //     if (roadmap?.[level]?.courses?.length) {
//   //       doc.fontSize(12).text('Courses:');
//   //       roadmap[level].courses.forEach(({ courseTitle, platform, URL, durationInWeeks }) => {
//   //         doc.fontSize(10).text(`• ${courseTitle} (${platform}, ${durationInWeeks} weeks)`);
//   //         doc.fillColor('blue').text(URL, { link: URL, underline: true }).fillColor('black');
//   //       });
//   //     }
//   //     if (roadmap?.[level]?.projectIdeas?.length) {
//   //       doc.fontSize(12).text('Project Ideas:');
//   //       roadmap[level].projectIdeas.forEach((idea) => {
//   //         doc.fontSize(10).text(`• ${idea}`);
//   //       });
//   //     }
//   //     doc.moveDown();
//   //   });

//   //   // Future Roles
//   //   doc.fontSize(16).text('Future Career Pathways');
//   //   roadmap?.futureRoles?.forEach(({ roleTitle, estimatedSalaryRange, jobMarketTrends }) => {
//   //     doc.fontSize(12).text(`• ${roleTitle}: ${estimatedSalaryRange}`);
//   //     doc.fontSize(10).text(jobMarketTrends);
//   //   });
//   //   doc.moveDown();

//   //   // Skill Match
//   //   doc.fontSize(16).text('Skill Match Analysis');
//   //   doc.fontSize(12).text(`Match Percentage: ${roadmap?.skillMatch?.matchPercentage || 0}%`);
//   //   if (roadmap?.skillMatch?.matchedSkills?.length) {
//   //     doc.fontSize(12).text('Matched Skills:');
//   //     doc.fontSize(10).text(roadmap.skillMatch.matchedSkills.join(', '));
//   //   }
//   //   if (roadmap?.skillMatch?.missingSkills?.length) {
//   //     doc.fontSize(12).text('Missing Skills:');
//   //     doc.fontSize(10).text(roadmap.skillMatch.missingSkills.join(', '));
//   //   }

//   //   doc.end();
//   //   stream.on('finish', () => {
//   //     const blob = stream.toBlob('application/pdf');
//   //     const url = URL.createObjectURL(blob);
//   //     const a = document.createElement('a');
//   //     a.href = url;
//   //     a.download = `Career_Roadmap_${careerGoal.replace(/\s+/g, '_')}.pdf`;
//   //     a.click();
//   //     URL.revokeObjectURL(url);
//   //   });
//   // };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <p className="text-gray-500">Loading...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl">
//           <p className="text-red-500 mb-4">{error}</p>
//           <button
//             onClick={() => navigate('/')}
//             className="bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition-colors duration-200"
//           >
//             Back to Prompt
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100 py-8">
//       <div className="container mx-auto px-4">
//         <div className="bg-white p-8 rounded-lg shadow-lg max-w-4xl mx-auto">
//           <h1 className="text-3xl font-bold mb-6 text-center">Career Roadmap: {careerGoal}</h1>
//           <div className="mb-6 flex justify-center">
//             {/* <button
//               onClick={generatePDF}
//               className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 transition-colors duration-200"
//             >
//               Download PDF
//             </button> */}
//           </div>

//           {/* Selected Skills */}
//           <section className="mb-8">
//             <h2 className="text-2xl font-semibold mb-4">Selected Skills</h2>
//             {Object.entries(selectedSkills).map(([category, skills]) => (
//               skills.length > 0 && (
//                 <div key={category} className="mb-4">
//                   <h3 className="text-lg font-medium">{category.charAt(0).toUpperCase() + category.slice(1)}</h3>
//                   <p className="text-gray-600">{skills.join(', ')}</p>
//                 </div>
//               )
//             ))}
//           </section>

//           {/* Required Skills */}
//           <section className="mb-8">
//             <h2 className="text-2xl font-semibold mb-4">Required Skills</h2>
//             <ul className="list-disc pl-6 space-y-2">
//               {roadmap?.requiredSkills?.map(({ skill, description }) => (
//                 <li key={skill}>
//                   <span className="font-medium">{skill}</span>: {description}
//                 </li>
//               ))}
//             </ul>
//           </section>

//           {/* Skill Gap */}
//           <section className="mb-8">
//             <h2 className="text-2xl font-semibold mb-4">Skill Gap Analysis</h2>
//             {roadmap?.skillGap?.missingSkill?.length > 0 && (
//               <div className="mb-4">
//                 <h3 className="text-lg font-medium">Missing Skills</h3>
//                 <p className="text-gray-600">{roadmap.skillGap.missingSkill.join(', ')}</p>
//               </div>
//             )}
//             {roadmap?.skillGap?.underdevelopedSkill?.length > 0 && (
//               <div>
//                 <h3 className="text-lg font-medium">Underdeveloped Skills</h3>
//                 <ul className="list-disc pl-6 space-y-2">
//                   {roadmap.skillGap.underdevelopedSkill.map(({ skill, currentProficiency, improvementSteps }) => (
//                     <li key={skill}>
//                       <span className="font-medium">{skill}</span> ({currentProficiency}%): {improvementSteps}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </section>

//           {/* Learning Plans */}
//           {['beginner', 'intermediate', 'advanced'].map((level) => (
//             <section key={level} className="mb-8">
//               <h2 className="text-2xl font-semibold mb-4">{level.charAt(0).toUpperCase() + level.slice(1)} Learning Plan</h2>
//               {roadmap?.[level]?.courses?.length > 0 && (
//                 <div className="mb-4">
//                   <h3 className="text-lg font-medium">Courses</h3>
//                   <ul className="list-disc pl-6 space-y-2">
//                     {roadmap[level].courses.map(({ courseTitle, platform, URL, durationInWeeks }) => (
//                       <li key={courseTitle}>
//                         <a href={URL} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
//                           {courseTitle}
//                         </a> ({platform}, {durationInWeeks} weeks)
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//               {roadmap?.[level]?.projectIdeas?.length > 0 && (
//                 <div>
//                   <h3 className="text-lg font-medium">Project Ideas</h3>
//                   <ul className="list-disc pl-6 space-y-2">
//                     {roadmap[level].projectIdeas.map((idea, index) => (
//                       <li key={index}>{idea}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </section>
//           ))}

//           {/* Future Roles */}
//           <section className="mb-8">
//             <h2 className="text-2xl font-semibold mb-4">Future Career Pathways</h2>
//             <ul className="list-disc pl-6 space-y-2">
//               {roadmap?.futureRoles?.map(({ roleTitle, estimatedSalaryRange, jobMarketTrends }) => (
//                 <li key={roleTitle}>
//                   <span className="font-medium">{roleTitle}</span>: {estimatedSalaryRange}
//                   <p className="text-gray-600">{jobMarketTrends}</p>
//                 </li>
//               ))}
//             </ul>
//           </section>

//           {/* Skill Match */}
//           <section className="mb-8">
//             <h2 className="text-2xl font-semibold mb-4">Skill Match Analysis</h2>
//             <p className="text-lg">Match Percentage: <span className="font-medium">{roadmap?.skillMatch?.matchPercentage || 0}%</span></p>
//             {roadmap?.skillMatch?.matchedSkills?.length > 0 && (
//               <div className="mb-4">
//                 <h3 className="text-lg font-medium">Matched Skills</h3>
//                 <p className="text-gray-600">{roadmap.skillMatch.matchedSkills.join(', ')}</p>
//               </div>
//             )}
//             {roadmap?.skillMatch?.missingSkills?.length > 0 && (
//               <div>
//                 <h3 className="text-lg font-medium">Missing Skills</h3>
//                 <p className="text-gray-600">{roadmap.skillMatch.missingSkills.join(', ')}</p>
//               </div>
//             )}
//           </section>

//           <div className="flex justify-center">
//             <button
//               onClick={() => navigate('/')}
//               className="bg-indigo-600 text-white py-2 px-6 rounded-md hover:bg-indigo-700 transition-colors duration-200"
//             >
//               Back to Prompt
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default RoadmapPage;



import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import axiosInstance from '../../../../../../../../store/axiosInstance';
import { SERVER_URL } from '../../../../../../../../Config/config';

function RoadmapPage() {
  const { state } = useLocation();
  const navigate = useNavigate();

  // Initialize state based on console log structure
  const [roadmap, setRoadmap] = useState(state?.roadmap.roadmap || null);

//   const [roadmap, setRoadmap] = useState( 
//  {
//         "requiredSkills": [
//             {
//                 "skill": "HTML/CSS",
//                 "description": "Fundamental for building user interfaces and ensuring cross-browser compatibility."
//             },
//             {
//                 "skill": "JavaScript",
//                 "description": "Essential for front-end interactivity and increasingly used in back-end development (Node.js)."
//             },
//             {
//                 "skill": "React",
//                 "description": "A popular JavaScript library for building user interfaces, known for its component-based architecture."
//             },
//             {
//                 "skill": "Node.js",
//                 "description": "A JavaScript runtime environment for building scalable server-side applications."
//             },
//             {
//                 "skill": "Express.js",
//                 "description": "A minimalist Node.js web application framework for building RESTful APIs and web applications."
//             },
//             {
//                 "skill": "Databases (SQL & NoSQL)",
//                 "description": "Knowledge of relational databases (e.g., PostgreSQL, MySQL) and NoSQL databases (e.g., MongoDB) is crucial for data management."
//             },
//             {
//                 "skill": "Git",
//                 "description": "Version control system for tracking changes to code and collaborating with other developers."
//             },
//             {
//                 "skill": "RESTful APIs",
//                 "description": "Designing and implementing RESTful APIs for communication between the front-end and back-end."
//             },
//             {
//                 "skill": "DevOps Principles",
//                 "description": "Understanding of CI/CD pipelines, containerization (Docker), and cloud deployment (AWS, Azure, GCP)."
//             },
//             {
//                 "skill": "Security Best Practices",
//                 "description": "Knowledge of common web vulnerabilities (e.g., OWASP Top 10) and secure coding practices."
//             },
//             {
//                 "skill": "C#",
//                 "description": "C# is a modern, object-oriented programming language used by Microsoft for .NET web development and backend services."
//             },
//             {
//                 "skill": "Software Architecture",
//                 "description": "Ability to design scalable, maintainable, and robust software systems."
//             }
//         ],
//         "skillGap": {
//             "missingSkill": [
//                 "HTML/CSS",
//                 "Node.js",
//                 "Express.js",
//                 "Databases (SQL & NoSQL)",
//                 "Git"
//             ],
//             "underdevelopedSkill": [
//                 {
//                     "missingSkill": "Azure",
//                     "currentProficiency": 67,
//                     "improvementSteps": [
//                         "Complete Azure certifications (e.g., Azure Developer Associate).",
//                         "Deploy and manage applications on Azure using various services (e.g., App Service, Azure Functions).",
//                         "Contribute to open-source projects that utilize Azure."
//                     ]
//                 },
//                 {
//                     "missingSkill": "Communication Skills",
//                     "currentProficiency": 88,
//                     "improvementSteps": [
//                         "Practice explaining technical concepts clearly to non-technical audiences.",
//                         "Participate in code reviews and provide constructive feedback.",
//                         "Attend workshops or courses on effective communication and presentation skills."
//                     ]
//                 },
//                 {
//                     "missingSkill": "MS Word",
//                     "currentProficiency": 0,
//                     "improvementSteps": [
//                         "Start with any beginner course and learn from the basics.",
//                         "After you get the gist of the skill, try to work on practical use cases for the tool."
//                     ]
//                 },
//                 {
//                     "missingSkill": "Teamwork",
//                     "currentProficiency": 0,
//                     "improvementSteps": [
//                         "Start with any beginner course and learn from the basics.",
//                         "After you get the gist of the skill, try to work on practical use cases for the tool."
//                     ]
//                 },
//                 {
//                     "missingSkill": "Creativity",
//                     "currentProficiency": 0,
//                     "improvementSteps": [
//                         "Start with any beginner course and learn from the basics.",
//                         "After you get the gist of the skill, try to work on practical use cases for the tool."
//                     ]
//                 }
//             ]
//         },
//         "beginner": {
//             "courses": [
//                 {
//                     "title": "The Web Developer Bootcamp 2024",
//                     "platform": "Udemy",
//                     "URL": "https://www.udemy.com/course/the-web-developer-bootcamp/",
//                     "durationInWeeks": 52
//                 },
//                 {
//                     "title": "freeCodeCamp's Responsive Web Design Certification",
//                     "platform": "freeCodeCamp",
//                     "URL": "https://www.freecodecamp.org/learn/2022/responsive-web-design/",
//                     "durationInWeeks": 20
//                 },
//                 {
//                     "title": "JavaScript Algorithms and Data Structures Certification",
//                     "platform": "freeCodeCamp",
//                     "URL": "https://www.freecodecamp.org/learn/javascript-algorithms-and-data-structures/",
//                     "durationInWeeks": 20
//                 }
//             ],
//             "projectIdeas": [
//                 "Build a simple to-do list application using HTML, CSS, and JavaScript.",
//                 "Create a personal portfolio website showcasing your skills and projects."
//             ]
//         },
//         "intermediate": {
//             "courses": [
//                 {
//                     "title": "React - The Complete Guide (incl Hooks, React Router, Redux)",
//                     "platform": "Udemy",
//                     "URL": "https://www.udemy.com/course/react-the-complete-guide-incl-hooks-react-router-redux/",
//                     "durationInWeeks": 26
//                 },
//                 {
//                     "title": "Node.js, Express, MongoDB & More: The Complete Bootcamp 2024",
//                     "platform": "Udemy",
//                     "URL": "https://www.udemy.com/course/nodejs-express-mongodb-bootcamp/",
//                     "durationInWeeks": 26
//                 },
//                 {
//                     "title": "SQL for Data Science",
//                     "platform": "Coursera",
//                     "URL": "https://www.coursera.org/learn/sql-for-data-science",
//                     "durationInWeeks": 4
//                 }
//             ],
//             "projectIdeas": [
//                 "Develop a RESTful API for a blog application using Node.js, Express, and MongoDB.",
//                 "Build a full-stack e-commerce application with React, Node.js, and a database of your choice."
//             ]
//         },
//         "advanced": {
//             "courses": [
//                 {
//                     "title": "Advanced React Patterns",
//                     "platform": "Frontend Masters",
//                     "URL": "https://frontendmasters.com/courses/advanced-react-patterns/",
//                     "durationInWeeks": 12
//                 },
//                 {
//                     "title": "Microservices with Node JS and React",
//                     "platform": "Udemy",
//                     "URL": "https://www.udemy.com/course/microservices-with-nodejs-and-react/",
//                     "durationInWeeks": 24
//                 },
//                 {
//                     "title": "Cloud Architecture with Google Cloud Platform",
//                     "platform": "Coursera",
//                     "URL": "https://www.coursera.org/professional-certificates/gcp-cloud-architect",
//                     "durationInWeeks": 20
//                 }
//             ],
//             "projectIdeas": [
//                 "Design and implement a scalable microservices architecture for a complex application.",
//                 "Contribute to an open-source project with a significant codebase.",
//                 "Build a cloud-native application deployed on Azure using serverless technologies."
//             ]
//         },
//         "futureRoles": [
//             {
//                 "Title": "Senior Full Stack Developer",
//                 "SalaryRange": "$120,000 - $180,000",
//                 "MarketTrends": "High demand for experienced developers with expertise in modern JavaScript frameworks and cloud technologies."
//             },
//             {
//                 "Title": "Software Architect",
//                 "SalaryRange": "$150,000 - $250,000",
//                 "MarketTrends": "Growing need for architects who can design and implement scalable, resilient, and secure software systems."
//             },
//             {
//                 "Title": "Tech Lead",
//                 "SalaryRange": "$140,000 - $220,000",
//                 "MarketTrends": "Companies seek skilled leaders who can mentor junior developers and guide technical direction."
//             }
//         ],
//         "skillMatch": {
//             "Percentage": 33,
//             "Skills": [
//                 "Azure",
//                 "Communication Skills",
//                 "RESTful APIs",
//                 "React",
//                 "C#",
//                 "DevOps Principles",
//                 "Software Architecture",
//                 "Security Best Practices"
//             ],
//             "MissingSkills": [
//                 "HTML/CSS",
//                 "JavaScript",
//                 "Node.js",
//                 "Express.js",
//                 "Databases (SQL & NoSQL)",
//                 "Git"
//             ]
//         }
//     }
// );

// const [roadmap, setRoadmap] = useState(

//   {
//     "requiredSkills": [
//         {
//             "skill": "Web3 Marketing Strategy",
//             "description": "Develop comprehensive marketing plans specifically tailored for Web3 products and services, including DAOs, NFTs, and decentralized applications."
//         },
//         {
//             "skill": "Community Building",
//             "description": "Foster active and engaged online communities around Web3 projects using platforms like Discord, Telegram, and Twitter."
//         },
//         {
//             "skill": "Content Marketing (Web3)",
//             "description": "Create engaging content, including blog posts, articles, videos, and infographics, that educates and attracts users to Web3 projects."
//         },
//         {
//             "skill": "Social Media Marketing (Web3)",
//             "description": "Manage and optimize social media campaigns on platforms like Twitter, Discord, and Reddit to promote Web3 products and services, using relevant hashtags and trends."
//         },
//         {
//             "skill": "SEO for Web3",
//             "description": "Optimize website and content for search engines, focusing on Web3-specific keywords to improve organic visibility."
//         },
//         {
//             "skill": "Blockchain Fundamentals",
//             "description": "Understand core blockchain concepts like consensus mechanisms, smart contracts, and decentralized governance to effectively communicate and market Web3 projects."
//         },
//         {
//             "skill": "DeFi Marketing",
//             "description": "Promote decentralized finance (DeFi) protocols and services to potential users and investors, focusing on benefits like yield farming and staking."
//         },
//         {
//             "skill": "NFT Marketing",
//             "description": "Develop and execute marketing strategies for non-fungible tokens (NFTs), including creating hype, driving sales, and building community around NFT projects."
//         },
//         {
//             "skill": "Web3 Analytics Tools",
//             "description": "Utilize analytics tools like Dune Analytics, Nansen, and Glassnode to track campaign performance, user behavior, and market trends in the Web3 space."
//         },
//         {
//             "skill": "Data Privacy Regulations (Web3)",
//             "description": "Understand data privacy regulations and compliance within the Web3 space to ensure ethical and legal marketing practices."
//         },
//         {
//             "skill": "Basic Solidity Knowledge",
//             "description": "Having a foundational understanding of Solidity helps you better understand the underlying technology your marketing efforts support."
//         }
//     ],
//     "skillGap": {
//         "0": {
//             "missingSkill": "Web3 Marketing Strategy"
//         },
//         "1": {
//             "missingSkill": "Community Building"
//         },
//         "2": {
//             "missingSkill": "Content Marketing (Web3)"
//         },
//         "3": {
//             "missingSkill": "SEO for Web3"
//         },
//         "4": {
//             "missingSkill": "Blockchain Fundamentals"
//         },
//         "5": {
//             "underdevelopedSkill": "Social Media Marketing (Web3)",
//             "currentProficiency": 0,
//             "improvementSteps": [
//                 "Research successful Web3 social media campaigns.",
//                 "Practice creating engaging content for Web3 audiences on Twitter and Discord.",
//                 "Analyze social media metrics to optimize campaign performance."
//             ]
//         },
//         "6": {
//             "underdevelopedSkill": "DeFi Marketing",
//             "currentProficiency": 0,
//             "improvementSteps": [
//                 "Study the basics of decentralized finance and its various applications.",
//                 "Identify the target audience for DeFi products and services.",
//                 "Create content and campaigns that highlight the benefits of DeFi."
//             ]
//         },
//         "7": {
//             "underdevelopedSkill": "NFT Marketing",
//             "currentProficiency": 0,
//             "improvementSteps": [
//                 "Explore different NFT marketplaces and projects.",
//                 "Learn about NFT minting, trading, and community building.",
//                 "Develop marketing strategies for NFT drops and collections."
//             ]
//         },
//         "8": {
//             "underdevelopedSkill": "Web3 Analytics Tools",
//             "currentProficiency": 0,
//             "improvementSteps": [
//                 "Familiarize yourself with analytics platforms like Dune Analytics and Nansen.",
//                 "Learn how to query and interpret data related to Web3 projects.",
//                 "Apply analytics insights to optimize marketing campaigns."
//             ]
//         },
//         "9": {
//             "underdevelopedSkill": "Basic Solidity Knowledge",
//             "currentProficiency": 0,
//             "improvementSteps": [
//                 "Take an introductory course on Solidity programming.",
//                 "Practice writing simple smart contracts.",
//                 "Understand how smart contracts interact with marketing campaigns."
//             ]
//         },
//         "missingSkill": [],
//         "underdevelopedSkill": []
//     },
//     "beginner": {
//         "courses": [
//             {
//                 "name": "Blockchain and Cryptocurrency Explained",
//                 "platform": "Coursera",
//                 "URL": "https://www.coursera.org/learn/blockchain-basics",
//                 "durationInWeeks": 4
//             },
//             {
//                 "name": "Web3 Foundations",
//                 "platform": "Udemy",
//                 "URL": "https://www.udemy.com/course/web3-foundations/",
//                 "durationInWeeks": 6
//             },
//             {
//                 "name": "NFT Fundamentals",
//                 "platform": "Udemy",
//                 "URL": "https://www.udemy.com/course/nft-masterclass-learn-everything-about-non-fungible-tokens/",
//                 "durationInWeeks": 4
//             },
//             {
//                 "name": "Social Media Marketing Specialization",
//                 "platform": "Coursera",
//                 "URL": "https://www.coursera.org/specializations/social-media-marketing",
//                 "durationInWeeks": 6
//             }
//         ],
//         "projectIdeas": [],
//         "projects": [
//             "Create a simple website promoting a fictional Web3 project.",
//             "Start a blog or social media account discussing Web3 topics and trends."
//         ]
//     },
//     "intermediate": {
//         "courses": [
//             {
//                 "name": "DeFi Deep Dive",
//                 "platform": "Udemy",
//                 "URL": "https://www.udemy.com/course/defi-deep-dive/",
//                 "durationInWeeks": 8
//             },
//             {
//                 "name": "Web3 Marketing Masterclass",
//                 "platform": "Skillshare",
//                 "URL": "https://www.skillshare.com/classes/Web3-Marketing-Masterclass-Grow-Your-Audience-Monetize-Your-Work/1646974882",
//                 "durationInWeeks": 6
//             },
//             {
//                 "name": "Solidity, Blockchain, and Smart Contracts",
//                 "platform": "freeCodeCamp",
//                 "URL": "https://www.youtube.com/watch?v=gyMwXuJutQQ",
//                 "durationInWeeks": 16
//             }
//         ],
//         "projectIdeas": [],
//         "projects": [
//             "Develop a marketing plan for a real-world DeFi project.",
//             "Launch and promote an NFT collection.",
//             "Analyze the performance of a Web3 marketing campaign using analytics tools."
//         ]
//     },
//     "advanced": {
//         "courses": [
//             {
//                 "name": "Advanced Web3 Marketing Strategies",
//                 "platform": "Udemy (Search for most recent)",
//                 "URL": "https://www.udemy.com/",
//                 "durationInWeeks": 8
//             },
//             {
//                 "name": "Blockchain Strategy",
//                 "platform": "Coursera",
//                 "URL": "https://www.coursera.org/specializations/blockchain-strategy",
//                 "durationInWeeks": 8
//             }
//         ],
//         "projectIdeas": [],
//         "projects": [
//             "Conduct a comprehensive market analysis for a Web3 vertical (e.g., gaming, metaverse).",
//             "Build a community-driven marketing strategy for a DAO.",
//             "Create a thought leadership piece on the future of Web3 marketing."
//         ]
//     },
//     "futureRoles": [
//         {
//             "Title": "Web3 Marketing Manager",
//             "SalaryRange(in USD)": "90,000 - 150,000",
//             "MarketTrends": "Increased demand for experienced Web3 marketers to lead marketing teams and strategies."
//         },
//         {
//             "Title": "Web3 Community Lead",
//             "SalaryRange(in USD)": "70,000 - 120,000",
//             "MarketTrends": "Growing importance of community building in Web3 projects, driving demand for skilled community leaders."
//         },
//         {
//             "Title": "Web3 Marketing Consultant",
//             "SalaryRange(in USD)": "100,000 - 200,000+",
//             "MarketTrends": "High demand for specialized Web3 marketing expertise from organizations navigating the Web3 landscape."
//         },
//         {
//             "Title": "Head of Web3 Marketing",
//             "SalaryRange(in USD)": "150,000 - 300,000+",
//             "MarketTrends": "As Web3 matures, companies are creating dedicated Web3 marketing leadership roles."
//         }
//     ],
//     "skillMatch": {
//         "Percentage": 45,
//         "ExistingSkills": [
//             "Azure",
//             "Communication Skills",
//             "RESTful APIs",
//             "Creativity",
//             "Social Media Marketing (Web3)",
//             "DeFi Marketing",
//             "NFT Marketing",
//             "Web3 Analytics Tools",
//             "Data Privacy Regulations (Web3)",
//             "Basic Solidity Knowledge"
//         ],
//         "NeededSkills": [
//             "Web3 Marketing Strategy",
//             "Community Building",
//             "Content Marketing (Web3)",
//             "SEO for Web3",
//             "Blockchain Fundamentals"
//         ]
//     }
// }
// )

console.log('state', state)
  const [careerGoal, setCareerGoal] = useState(state?.skills?.careerGoal || 'Unknown');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchRoadmap = async () => {
  //     setLoading(true);
  //     setError(null);
  //     try {
  //       const response = await axiosInstance.get(`${SERVER_URL}/api/v1/career-gpt/get-roadmap`);
  //       setRoadmap(response.data.roadmap);
  //       setCareerGoal(response.data.roadmap.careerGoal || 'Unknown');
  //     } catch (error) {
  //       setError('Error fetching roadmap: ' + (error.response?.data?.error || error.message));
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (!state?.roadmap) {
  //     fetchRoadmap();
  //   } else {
  //     setRoadmap(state.roadmap);
  //     setLoading(false);
  //   }
  // }, [state]);

  // const generatePDF = () => {
  //   const doc = new PDFDocument({ margin: 40 });
  //   const stream = doc.pipe(blobStream());
  //   doc.fontSize(24).text(`Career Roadmap: ${careerGoal}`, { align: 'center' });
  //   doc.moveDown();
  //   doc.fontSize(12).text(`Generated for User ID: 1005`, { align: 'center' });
  //   doc.moveDown(2);
  //   doc.fontSize(16).text('Required Skills');
  //   roadmap?.requiredSkills?.forEach(({ skill, description }) => {
  //     doc.fontSize(12).text(`• ${skill}: ${description}`);
  //   });
  //   doc.moveDown();
  //   doc.fontSize(16).text('Skill Gap Analysis');
  //   if (roadmap?.skillGap?.missingSkill?.length) {
  //     doc.fontSize(12).text('Missing Skills:');
  //     doc.fontSize(10).text(roadmap.skillGap.missingSkill.join(', '));
  //   }
  //   if (roadmap?.skillGap?.underdevelopedSkill?.length) {
  //     doc.fontSize(12).text('Underdeveloped Skills:');
  //     roadmap.skillGap.underdevelopedSkill.forEach(({ missingSkill, currentProficiency, improvementSteps }) => {
  //       doc.fontSize(10).text(`• ${missingSkill} (${currentProficiency}%): ${improvementSteps.join('; ')}`);
  //     });
  //   }
  //   doc.moveDown();
  //   ['beginner', 'intermediate', 'advanced'].forEach((level) => {
  //     doc.fontSize(16).text(`${level.charAt(0).toUpperCase() + level.slice(1)} Learning Plan`);
  //     if (roadmap?.[level]?.courses?.length) {
  //       doc.fontSize(12).text('Courses:');
  //       roadmap[level].courses.forEach(({ title, platform, URL, durationInWeeks }) => {
  //         doc.fontSize(10).text(`• ${title} (${platform}, ${durationInWeeks} weeks)`);
  //         doc.fillColor('blue').text(URL, { link: URL, underline: true }).fillColor('black');
  //       });
  //     }
  //     if (roadmap?.[level]?.projectIdeas?.length) {
  //       doc.fontSize(12).text('Project Ideas:');
  //       roadmap[level].projectIdeas.forEach((idea) => {
  //         doc.fontSize(10).text(`• ${idea}`);
  //       });
  //     }
  //     doc.moveDown();
  //   });
  //   doc.fontSize(16).text('Future Career Pathways');
  //   roadmap?.futureRoles?.forEach(({ Title, SalaryRange, MarketTrends }) => {
  //     doc.fontSize(12).text(`• ${Title}: ${SalaryRange}`);
  //     doc.fontSize(10).text(MarketTrends);
  //   });
  //   doc.moveDown();
  //   doc.fontSize(16).text('Skill Match Analysis');
  //   doc.fontSize(12).text(`Match Percentage: ${roadmap?.skillMatch?.Percentage || 0}%`);
  //   if (roadmap?.skillMatch?.Skills?.length) {
  //     doc.fontSize(12).text('Matched Skills:');
  //     doc.fontSize(10).text(roadmap.skillMatch.Skills.join(', '));
  //   }
  //   if (roadmap?.skillMatch?.MissingSkills?.length) {
  //     doc.fontSize(12).text('Missing Skills:');
  //     doc.fontSize(10).text(roadmap.skillMatch.MissingSkills.join(', '));
  //   }
  //   doc.end();
  //   stream.on('finish', () => {
  //     const blob = stream.toBlob('application/pdf');
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `Career_Roadmap_${careerGoal.replace(/\s+/g, '_')}.pdf`;
  //     a.click();
  //     URL.revokeObjectURL(url);
  //   });
  // };

  if (!loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="flex items-center space-x-3">
          <svg className="animate-spin h-8 w-8 text-indigo-600" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z" />
          </svg>
          <p className="text-lg font-medium text-indigo-600">Loading Roadmap...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-full">
          <p className="text-red-500 text-lg font-semibold mb-4">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition-colors duration-300"
          >
            Back to Prompt
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-gradient-to-r from-indigo-600 to-blue-500 p-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-white text-center">
              Career Roadmap: {careerGoal}
            </h1>
            <p className="text-indigo-100 text-center mt-2">Your path to becoming a Full Stack Developer</p>
          </div>

          <div className="p-8 space-y-12">
            {/* Required Skills */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Required Skills</h2>
              <div className="grid gap-4 sm:grid-cols-2">
                {roadmap?.requiredSkills?.map(({ skill, description }) => (
                  <div key={skill} className="bg-gray-50 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    <h3 className="text-lg font-medium text-indigo-600">{skill}</h3>
                    <p className="text-gray-600 text-sm">{description}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Skill Gap Analysis */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Skill Gap Analysis</h2>
              {roadmap?.skillGap?.missingSkill?.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-700">Missing Skills</h3>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {roadmap.skillGap.missingSkill.map((skill) => (
                      <span key={skill} className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {roadmap?.skillGap?.underdevelopedSkill?.length > 0 && (
                <div>
                  <h3 className="text-lg font-medium text-gray-700">Underdeveloped Skills</h3>
                  <div className="space-y-4 mt-2">
                    {roadmap.skillGap.underdevelopedSkill.map(({ missingSkill, currentProficiency, improvementSteps }) => (
                      <div key={missingSkill} className="bg-yellow-50 p-4 rounded-lg shadow-sm">
                        <div className="flex justify-between items-center">
                          <h4 className="text-md font-medium text-yellow-800">{missingSkill}</h4>
                          <span className="text-sm text-yellow-600">{currentProficiency}%</span>
                        </div>
                        <ul className="list-disc pl-5 mt-2 text-gray-600 text-sm">
                          {improvementSteps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </section>

            {/* Learning Plans */}
            {['beginner', 'intermediate', 'advanced'].map((level) => (
              <section key={level}>
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                  {level.charAt(0).toUpperCase() + level.slice(1)} Learning Plan
                </h2>
                {roadmap?.[level]?.courses?.length > 0 && (
                  <div className="mb-6">
                    <h3 className="text-lg font-medium text-gray-700">Recommended Courses</h3>
                    <div className="space-y-4 mt-2">
                      {roadmap[level].courses.map(({ title, platform, URL, durationInWeeks }) => (
                        <div key={title} className="bg-blue-50 p-4 rounded-lg shadow-sm">
                          <a
                            href={URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 font-medium hover:underline"
                          >
                            {title}
                          </a>
                          <p className="text-gray-600 text-sm mt-1">
                            {platform} • {durationInWeeks} weeks
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {roadmap?.[level]?.projectIdeas?.length > 0 && (
                  <div>
                    <h3 className="text-lg font-medium text-gray-700">Project Ideas</h3>
                    <ul className="list-disc pl-5 mt-2 text-gray-600 text-sm space-y-2">
                      {roadmap[level].projectIdeas.map((idea, index) => (
                        <li key={index}>{idea}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </section>
            ))}

            {/* Future Career Pathways */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Future Career Pathways</h2>
              <div className="grid gap-4 sm:grid-cols-2">
                {roadmap?.futureRoles?.map(({ Title, SalaryRange, MarketTrends }) => (
                  <div key={Title} className="bg-green-50 p-4 rounded-lg shadow-sm">
                    <h3 className="text-lg font-medium text-green-800">{Title}</h3>
                    <p className="text-gray-600 text-sm">Salary: {SalaryRange}</p>
                    <p className="text-gray-600 text-sm mt-1">{MarketTrends}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Skill Match Analysis */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Skill Match Analysis</h2>
              <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
                <p className="text-lg font-medium text-gray-700">
                  Match Percentage: <span className="text-indigo-600">{roadmap?.skillMatch?.Percentage || 0}%</span>
                </p>
                {roadmap?.skillMatch?.Skills?.length > 0 && (
                  <div className="mt-4">
                    <h3 className="text-lg font-medium text-gray-700">Matched Skills</h3>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {roadmap.skillMatch.Skills.map((skill) => (
                        <span key={skill} className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {roadmap?.skillMatch?.MissingSkills?.length > 0 && (
                  <div className="mt-4">
                    <h3 className="text-lg font-medium text-gray-700">Missing Skills</h3>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {roadmap.skillMatch.MissingSkills.map((skill) => (
                        <span key={skill} className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </section>

            {/* Navigation Buttons */}
            <div className="flex justify-center space-x-4">
              {/* <button
                onClick={generatePDF}
                className="bg-blue-600 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-colors duration-300"
              >
                Download PDF
              </button> */}
              <button
                onClick={() => navigate('/')}
                className="bg-indigo-600 text-white py-2 px-6 rounded-lg hover:bg-indigo-700 transition-colors duration-300"
              >
                Back to Prompt
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RoadmapPage;